/* eslint-disable linebreak-style */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GreenroomState as GS } from '../../stores/types/types';
import SlidingMenu, { SlidingMenuOption } from '../general-components/sliding-menu';
import { TABS } from '../../stores/reducers/session';
import Animation from './settings/animation';
import * as SessionActions from '../../stores/actions/session';
import { SHOT_MODAL_TABS } from '../modal/templates/shot-builder/shot-edit-ui';
import ContentGeneratorHandler from './settings/content-generator-handler';
import ContentFormProvider from '../../contexts/generated-content/content-form-context';

interface Props {
	updateParentTab: Function;
	parentTab: string;
	previousTab: any;
	isForShotEditorModal?: boolean;
}

export const OVERLAY_SETTINGS_TABS = {
	ANIMATION: 0,
	TITLE: 1,
};

const menuOptions: SlidingMenuOption[] = [
	{ label: 'Content', data: { value: OVERLAY_SETTINGS_TABS.TITLE } },
	{ label: 'Animation', data: { value: OVERLAY_SETTINGS_TABS.ANIMATION } },
];

export default function OverlaysSettings(props: Props) {
	const {
		updateParentTab,
		parentTab,
		previousTab,
		isForShotEditorModal = false,
	} = props;

	const currentGraphicId = useSelector((s: GS) => s.GraphicsReducer.currentGraphicId);
	const shotModalGraphics = useSelector((s: GS) => s.GraphicsReducer.shotModalGraphics);
	const graphics = useSelector((s: GS) => s.GraphicsReducer.graphics);

	const selectedGraphic = isForShotEditorModal
		// eslint-disable-next-line max-len
		? shotModalGraphics.find((g) => g.id === currentGraphicId) || graphics.find((g) => g.id === currentGraphicId)
		: graphics.find((g) => g.id === currentGraphicId);

	const isGeneratedCont = !!selectedGraphic?.template_type;
	const actualMenuOptions = isGeneratedCont ? menuOptions : [menuOptions[1]];
	// @TODO: at some point this will need to come from a setting, only one tab for now
	const [currentTab, setCurrentTab] = useState(isGeneratedCont ? menuOptions[0] : menuOptions[1]);

	const dispatch = useDispatch();

	useEffect(() => {
		if (selectedGraphic?.id && parentTab !== TABS.OVERLAYS) {
			updateParentTab(!isForShotEditorModal ? TABS.OVERLAYS : SHOT_MODAL_TABS.OVERLAYS);
			setCurrentTab(actualMenuOptions[0]);
		} else if (!selectedGraphic?.id && (parentTab === TABS.OVERLAYS || isForShotEditorModal)) {
			updateParentTab(previousTab);
			if (!isForShotEditorModal && previousTab === TABS.NONE) {
				dispatch(SessionActions.setRightDrawerOpen(false));
			}
		} else {
			setCurrentTab(actualMenuOptions[0]);
		}
	}, [selectedGraphic?.id]);

	if (!selectedGraphic || parentTab !== TABS.OVERLAYS) {
		return (
			<>&nbsp;</>
		);
	}

	return (<>
		<SlidingMenu
			options={actualMenuOptions}
			selectedOption={currentTab ?? menuOptions[0]}
			callback={(o: SlidingMenuOption) => setCurrentTab(o)}
			className="padding-left-small position-relative width-calc-full"
			fullWidthDivider={true}
		/>
		{currentTab?.data?.value === OVERLAY_SETTINGS_TABS.ANIMATION && (
			<div className="shot-builder-modal-media-container">
				<div className="position-relative margin-bottom-medium">
					<Animation isForShotEditorModal={isForShotEditorModal} />
				</div>
			</div>
		)}
		{currentTab?.data?.value === OVERLAY_SETTINGS_TABS.TITLE && isGeneratedCont && (
			<ContentFormProvider isForShotEditorModal={isForShotEditorModal}>
				<ContentGeneratorHandler/>
			</ContentFormProvider>
		)}
	</>);
}
